export function stringToTime(time: string) {
  if (time === null) {
    return undefined;
  }

  const timeString = time?.slice(0, 2) + ":" + time.slice(2, 4);

  return timeString;
}
